import { render, staticRenderFns } from "./CuadraturaOrdenesServicio.vue?vue&type=template&id=b983b6c6&"
import script from "./CuadraturaOrdenesServicio.vue?vue&type=script&lang=ts&"
export * from "./CuadraturaOrdenesServicio.vue?vue&type=script&lang=ts&"
import style0 from "./CuadraturaOrdenesServicio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b983b6c6', component.options)
    } else {
      api.reload('b983b6c6', component.options)
    }
    module.hot.accept("./CuadraturaOrdenesServicio.vue?vue&type=template&id=b983b6c6&", function () {
      api.rerender('b983b6c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/OrdenesServicio/CuadraturaOrdenesServicio.vue"
export default component.exports